<template>  
  <div class="board-shimmer-flex">
    <div v-for="n in 6" :key="n" class="board-card-shimmer">
      <div class="d-flex align-items-center justify-content-between">
        <b-skeleton class="assign"></b-skeleton>
        <b-skeleton class="tag"></b-skeleton>
      </div>
      <div v-for="a in 4" :key="a" class="board-shimmer">
        <div></div>
        <div>
          <div>
            <b-skeleton class="assign"></b-skeleton>
          </div>
  
          <div class=" ">
            <div class="teamuserName d-flex align-items-center">
              <b-skeleton class="tag"></b-skeleton>
              <b-skeleton class="tag"></b-skeleton>
              <b-skeleton class="tag"></b-skeleton>
              <b-skeleton class="tag"></b-skeleton>
              <b-skeleton class="tag"></b-skeleton>
              <b-skeleton class="tag"></b-skeleton>
            </div>
          </div>
          <b-skeleton class="assign"></b-skeleton>
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <skeleton-loader-vue
                type="circle"
                :width="30"
                :height="30"
                animation="wave"
                class="mr-2"
              />
            </div>
            <div>
              <b-skeleton class="assign mb-0"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import SkeletonLoaderVue from "skeleton-loader-vue"

export default {
  name: "MyteamdtlShimmer",
  components: {
    SkeletonLoaderVue,
  },
}
</script>

<style>
.tag {
  width: 40px;
  margin-right: 5px;
}
.assign {
  width: 100px;
}
.board-shimmer {
  max-width: 280px;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.2509803922),
    0px 0px 1px rgba(9, 30, 66, 0.3098039216);
}
.board-card-shimmer {
  background-color: #f1f2f4;
  border-radius: 12px;
  padding: 12px;
  max-width: 290px;
}
.board-shimmer-flex{
  display: flex;
  gap: 12px;
  margin-top: 20px;
}
</style>
